import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RxUtils, Tr } from '@utils';
import { notificationService, NotificationType, stockService } from '@services';
import { Stack } from '@mui/material';
import { PortalPageTitle } from '@components/portal/common';
import { AddEditStockForm } from '@components/portal/stock';

export const AddStock: FC = () => {
	const { t } = useTranslation('portal');
	const navigate = useNavigate();

	return (
		<Stack direction="column" sx={{ height: 1.0, maxHeight: 1.0, flexGrow: 1, paddingY: 5 }}>
			<PortalPageTitle
				paddingX={3}
				title={<Tr.Portal path="stock.add-edit-stock.add-title" />}
				subtitle={<Tr.Portal path="stock.add-edit-stock.add-subtitle" />}
				onBackButtonClick={() => navigate(-1)}
			/>
			<AddEditStockForm
				onSubmit={(values, images) =>
					RxUtils.promisify(stockService.create(values, images), () => {
						notificationService.send({ type: NotificationType.SUCCESS, message: t('stock.add-edit-stock.create-success') });
						navigate('..');
					})
				}
			/>
		</Stack>
	);
};
